module.exports = __webpack_public_path__ + "img/calendar2-check.7aecf4f7.svg";